import { Chart } from 'chart.js';

export default function commissionsOverview() {
    const chartCanvas = document.getElementById('commissionsChart');
    
    if (!chartCanvas) {
        console.log('Chart canvas not found');
        return;
    }
    
    const chartData = JSON.parse(chartCanvas.dataset.chartData);
    
    // Calculate totals
    const previousYearTotal = chartData.previousYear.reduce((sum, value) => sum + value, 0);
    const currentYearTotal = chartData.currentYear.reduce((sum, value) => sum + value, 0);
    
    const config = {
        type: 'bar',
        data: {
            labels: chartData.labels,
            datasets: [
                {
                    label: 'Vorig jaar (€ ' + previousYearTotal.toLocaleString('nl-NL', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ')',
                    data: chartData.previousYear,
                    backgroundColor: 'rgba(60, 100, 180, 0.2)',
                    borderColor: 'rgba(60, 100, 180, 0.5)',
                    borderWidth: 1
                },
                {
                    label: 'Huidig jaar (€ ' + currentYearTotal.toLocaleString('nl-NL', {minimumFractionDigits: 2, maximumFractionDigits: 2}) + ')',
                    data: chartData.currentYear,
                    backgroundColor: 'rgba(217, 177, 85, 1)',
                    borderColor: 'rgba(205, 157, 46, 1)',
                    borderWidth: 1
                }
            ]
        },
        options: {
            responsive: true,
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        callback: function(value) {
                            return '€ ' + value.toLocaleString('nl-NL', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                        }
                    }
                }]
            },
            tooltips: {
                callbacks: {
                    title: function(tooltipItems, data) {
                        const item = tooltipItems[0];
                        const index = item.index;
                        const datasetIndex = item.datasetIndex;
                        
                        // Show the full month + year in tooltip title
                        const label = datasetIndex === 0 
                            ? chartData.previousYearLabels[index]
                            : chartData.currentYearLabels[index];
                        
                        // Capitalize first letter
                        return label.charAt(0).toUpperCase() + label.slice(1);
                    },
                    label: function(tooltipItem, data) {
                        return 'Commissie: € ' + tooltipItem.yLabel.toLocaleString('nl-NL', {minimumFractionDigits: 2, maximumFractionDigits: 2});
                    }
                }
            }
        }
    };
    
    const chart = new Chart(chartCanvas.getContext('2d'), config);
}